export default __webpack_public_path__ + "static/media/Group 5839.1de01fac.svg";